module.exports = __webpack_public_path__ + "static/media/scholarActivitiesWhite.52c03609.svg";